import axios from 'axios'
import { getToken, hasToken } from '@utils/auth'
import _ from 'lodash'
import { getLocale } from '@utils/locale'

const service = axios.create({
  baseURL: 'https://api.jpworldpay.com/api/v1',
  timeout: 600000,
})

export const getHeaders = () => {
  const headers = {}
  const token = getToken()

  headers['Accept-Language'] = getLocale()
  if (hasToken()) {
    headers.Authorization = `Bearer ${token}`
  }

  return headers
}

service.interceptors.request.use(
  (config) => {
    config.headers = { ...config.headers, ...getHeaders() }

    return config
  },
  (error) => Promise.reject(error)
)

service.interceptors.response.use(
  (response) => {
    const res = response.data
    return _.chain({})
      .extend(res)
      .omit('variables')
      .extend(res.variables)
      .value()
  },
  (error) => {
    let result = null
    if (error.response && error.response.data) {
      result = _.chain({})
        .extend(error.response.data)
        .omit('variables')
        .extend(error.response.data.variables)
        .value()
    } else {
      result = {
        error: -1,
        message: error.message,
        httpStatusCode: error.response ? error.response.status : null,
      }
    }
    return Promise.reject(result)
  }
)

export default service
